import { Controller } from "@hotwired/stimulus"

// Muestra/oculta secciones según el valor de un <select>.
//
// Uso en ERB:
//   <div data-controller="manage--select-toggle">
//     <select data-action="manage--select-toggle#update"
//             data-manage--select-toggle-target="select">
//       <option value="none">Ninguna</option>
//       <option value="go_to_url">Ir a URL</option>
//     </select>
//     <div data-manage--select-toggle-target="section" data-show-when="go_to_url" class="hidden">
//       ...campos visibles solo cuando select == "go_to_url"...
//     </div>
//   </div>

export default class extends Controller {
  static targets = ["select", "section"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.selectTarget.value
    this.sectionTargets.forEach((section) => {
      const showWhen = section.dataset.showWhen
      const showUnless = section.dataset.showUnless
      let hidden
      if (showUnless !== undefined) {
        const excluded = showUnless.split(",").map((v) => v.trim())
        hidden = excluded.includes(selected)
      } else {
        const allowed = (showWhen || "").split(",").map((v) => v.trim())
        hidden = !allowed.includes(selected)
      }
      section.classList.toggle("hidden", hidden)
      section.querySelectorAll("input, select, textarea").forEach((input) => {
        if (hidden) {
          if (input.name) input.dataset.originalName = input.name
          input.name = ""
        } else {
          if (input.dataset.originalName) {
            input.name = input.dataset.originalName
            delete input.dataset.originalName
          }
        }
      })
    })
  }
}
